import { ActionTree } from 'vuex';
import { PartiesState } from './types';
import { RootState } from '@/types';
import { partyService } from '@/services/party.services';


export const actions: ActionTree<PartiesState, RootState> = {
    get({ commit }, {
        page = 1,
        perPage = 10,
        search = '',
        archived = false,
        sortBy = '',
        sortDesc = false,
    }): any {
        commit('setLoading');
        partyService.index(page, perPage, search, archived, sortBy, sortDesc)
        .then((response) => {
            const payload: any = response && response.data;
            commit('setData', payload);
        }, (error) => {
            commit('setError', error);
        });
    },
    post({ dispatch }, {
        party,
        page = 1,
        perPage = 10,
        search = '',
        archived = false,
        sortBy = '',
        sortDesc = false,
    }): any {
        let post;
        if (party.id) {
            post = partyService.put(party.id, party);
        } else {
            post = partyService.post(party);
        }
        post.then(() => {
            dispatch('get', { page, perPage, search, archived, sortBy, sortDesc });
        });
    },
    delete({ dispatch }, {
        id,
        page = 1,
        perPage = 10,
        search = '',
        archived = false,
        sortBy = '',
        sortDesc = false,
    }): any {
        partyService.deleteParty(id)
        .then(() => {
            dispatch('get', { page, perPage, search, archived, sortBy, sortDesc });
        });
    },
};
